import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_OpenTelemetry = {
    v1: {
        sendTelemetry: { method: HttpMethod.POST, path: '/v1/open-telemetry/send-telemetry' },
        triggerTest: { method: HttpMethod.POST, path: '/v1/open-telemetry/trigger-test' },
    }
};
//# sourceMappingURL=apis.js.map